import React from "react";

import logoImg from "../../assets/logos/side-logo.png";
import { useGetCurrentBrandingQuery } from "../../features/branding/brandingApiSlice";

const SideLogo = () => {
	const { data: branding } = useGetCurrentBrandingQuery();

	return (
		<img
			src={branding?.logoVertical ? branding.logoVertical : logoImg}
			style={{ marginTop: "auto", padding: "0 14px 32px 14px" }}
			alt=""
		/>
	);
};

export default SideLogo;
